const portfolioItems = [
  {
    title: 'Revestimento de Barragem',
    image: 'https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,h=487,fit=crop/A0xVvobDbRIBrVE7/tailing-dams-liner-mk39EqeW8bFEE14P.png',
    alt: 'Revestimento de barragem com geomembrana PEAD',
  },
  {
    title: 'Liner HDPE em Reservatório',
    image: 'https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,h=487,fit=crop/A0xVvobDbRIBrVE7/hdpe-liner-26-Aq2okqLPjOSgDPWk.png',
    alt: 'Instalação de liner HDPE em reservatório industrial',
  },
  {
    title: 'Impermeabilização em Obra',
    image: 'https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,h=487,fit=crop/A0xVvobDbRIBrVE7/hdpe-liner-21-ALpol7annKiOZx7j.png',
    alt: 'Obra de impermeabilização com geomembrana em campo',
  },
];

export default function PortfolioSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="text-center mb-10 md:mb-14">
          <span className="text-primary-500 text-xs uppercase tracking-widest mb-2 block">Portfólio</span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 uppercase leading-tight mb-3">Trabalhos Realizados</h2>
          <p className="text-foreground-500 text-sm max-w-md mx-auto">Projetos de soldagem de geomembrana executados com nossas máquinas em todo o Brasil.</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 md:gap-6">
          {portfolioItems.map((item) => (
            <div key={item.title} className="group relative w-full h-52 md:h-60 rounded-2xl overflow-hidden">
              <img
                alt={item.alt}
                className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-700"
                src={item.image}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-900/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4 md:p-5">
                <span className="text-white text-sm font-bold uppercase tracking-wide">{item.title}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}